import { cn } from 'mode-shared/utils';

export const NoData = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex items-center justify-center h-full w-full', className)}>
      <p className="text-neutral-500 text-sm font-medium">No data available</p>
    </div>
  );
};
